import { render } from "./notificaciones.vue?vue&type=template&id=04e92daf"
import script from "./notificaciones.vue?vue&type=script&lang=js"
export * from "./notificaciones.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__